module.exports = __webpack_public_path__ + "img/app_Id.02f91c10.png";